import { render } from "./ProfileUpdate.vue?vue&type=template&id=004f47da"
import script from "./ProfileUpdate.vue?vue&type=script&lang=js"
export * from "./ProfileUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__